import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

const mountScrolly = () => {
  const containers = document.querySelectorAll(".mapbox-scrollytelling");

  containers.forEach((container) => {
    if (container.dataset.vueMounted === "true") {
      return;
    }

    new Vue({
      render: (h) =>
        h(App, {
          props: {
            id: container.id,
          },
        }),
    }).$mount(container);

    container.dataset.vueMounted = "true";
  });
};

const init = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  mountScrolly();

  // Expose manual trigger for environments where the script loads after DOMContentLoaded.
  window.__fazScrollyMount = mountScrolly;
};

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
}
